import { Head, router } from "@inertiajs/react";
import {
  AlertCircle,
  Ban,
  FileQuestion,
  ServerCrash,
  ShieldAlert,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const STATUS_CONFIG: Record<
  number,
  { title: string; description: string; icon: React.ElementType }
> = {
  403: {
    title: "Acesso negado",
    description:
      "Você não tem permissão para acessar esta página. Verifique suas credenciais ou entre em contato com um administrador.",
    icon: ShieldAlert,
  },
  404: {
    title: "Página não encontrada",
    description:
      "A página que você está procurando não existe ou foi movida. Verifique o endereço digitado.",
    icon: FileQuestion,
  },
  422: {
    title: "Requisição inválida",
    description:
      "Não foi possível processar sua solicitação. Verifique os dados enviados e tente novamente.",
    icon: Ban,
  },
  500: {
    title: "Erro interno do servidor",
    description:
      "Ocorreu um erro inesperado. Nossa equipe foi notificada e está trabalhando para resolver o problema.",
    icon: ServerCrash,
  },
  503: {
    title: "Serviço indisponível",
    description:
      "O serviço está temporariamente indisponível. Tente novamente em alguns minutos.",
    icon: ServerCrash,
  },
};

const DEFAULT_CONFIG = {
  title: "Algo deu errado",
  description: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
  icon: AlertCircle,
};

export default function ErrorShow({ status }: { status: number }) {
  const config = STATUS_CONFIG[status] ?? DEFAULT_CONFIG;
  const Icon = config.icon;

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Head title={`${status} - ${config.title}`} />
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-muted">
            <Icon className="size-6 text-muted-foreground" />
          </div>
          <CardTitle>{config.title}</CardTitle>
          <CardDescription>{config.description}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-5xl font-bold">{status}</p>
        </CardContent>
        <CardFooter className="justify-center">
          <Button variant="outline" onClick={() => router.visit("/")}>
            Voltar para o início
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
